import React, { PureComponent } from 'react';
import { withRouter, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { push as changeLocation } from 'connected-react-router';
import PropTypes from 'prop-types';
import { Tabs, Tab, Icon } from '@blueprintjs/core';
import { PERMISSIONS } from '@moleculeone/auth';

import { hasAnyPermission } from '@f/services/authentication/authentication.selectors';
import Toolbar from '@f/components/shared/toolbar/Toolbar';
import { Sidebar } from '@f/components/shared/sidebar';

import ApiTokens from './pages/api-tokens/ApiTokensPage';
import PresetList from './pages/preset-list/PresetList';
import Preset from './pages/preset/Preset';
import cls from './SettingsPage.module.css';

const getRouteInfo = props => [
  {
    'path': `${props.match.url}/synthesis-plan-parameters`,
    'component': PresetList,
    'toolbarContext': PresetList.ToolbarContext,
    'text': 'Synthesis plan parameters',
    'icon': 'properties',
    'exact': true,
    'data-test': 'reaction-search-parameters-tab',
  },
  {
    path: `${props.match.url}/synthesis-plan-parameters/:userSearchParametersId/edit`,
    component: Preset,
    toolbarContext: Preset.ToolbarContext,
    doNotShowLink: true,
  },
  {
    path: `${props.match.url}/synthesis-plan-parameters/new`,
    component: Preset,
    toolbarContext: Preset.ToolbarContext,
    doNotShowLink: true,
  },
  {
    'path': `${props.match.url}/api-tokens`,
    'component': ApiTokens,
    'text': 'API tokens',
    'icon': 'barcode',
    'disabled': !props.isApiTokenUser,
    'data-test': 'api-tokens-tab',
  },
];

class UserProfilePage extends PureComponent {
  static propTypes = {
    router: PropTypes.object,
    changeLocation: PropTypes.func,
  };

  getSelectedTabId = routeInfo => {
    const { router } = this.props;
    const { pathname } = router.location;
    return routeInfo.find(route => pathname.startsWith(route.path))?.path;
  };

  onTabChange = path => {
    this.props.changeLocation(path);
  };

  render() {
    const routeInfo = getRouteInfo(this.props);
    const selectedTabId = this.getSelectedTabId(routeInfo);

    return (
      <div className={cls.page} data-test="user-profile-page">
        <Toolbar className={cls.toolbar}>
          <Sidebar title="Settings">
            <Tabs fill large vertical selectedTabId={selectedTabId} onChange={this.onTabChange}>
              {routeInfo.map((route, i) => {
                if (route.disabled || route.doNotShowLink) {
                  return null;
                }

                return (
                  <Tab
                    className={cls.menuTab}
                    id={route.path}
                    title={
                      <div className={cls.menuTabTitle}>
                        <Icon icon={route.icon} iconSize={Icon.SIZE_LARGE} />
                        <span>{route.text}</span>
                      </div>
                    }
                    key={String(i)}
                    data-test={route['data-test']}
                  />
                );
              })}
            </Tabs>
          </Sidebar>
          <div className={cls.toolbarContext}>
            {routeInfo.map((route, i) => {
              return <Route path={route.path} component={route.toolbarContext} key={String(i)} exact={route.exact} />;
            })}
          </div>
        </Toolbar>

        <div className={cls.content}>
          <Switch>
            {routeInfo.map((route, i) => {
              if (route.disabled) {
                return null;
              }

              return <Route path={route.path} component={route.component} key={String(i)} exact={route.exact} />;
            })}

            <Redirect to={routeInfo[0].path} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default withRouter(
  connect(
    state => ({
      router: state.router,
      isApiTokenUser: hasAnyPermission(state, [PERMISSIONS.RETRO.API.READ]),
    }),
    { changeLocation }
  )(UserProfilePage)
);
